"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnexSheetImpl = void 0;
const luxon_1 = require("luxon");
const utils_1 = require("./utils");
/**
 * Une fiche annexe formatée
 * @document ../process/newAnnexSheet.md
 */
class AnnexSheetImpl {
    constructor(sheet) {
        this.id = sheet.id;
        this.external_id = sheet.external_id;
        this.kind = sheet.kind;
        this.free_text = sheet.free_text;
        this.sign = sheet.sign;
        this.created_at_luxon = luxon_1.DateTime.fromISO(sheet.created_at).setZone('Europe/Paris').setLocale('fr-fr');
        this.updated_at_luxon = luxon_1.DateTime.fromISO(sheet.updated_at).setZone('Europe/Paris').setLocale('fr-fr');
        this.created_at = sheet.created_at;
        this.updated_at = sheet.updated_at;
        this.display_name = this.getDisplayName();
        if ((0, utils_1.isJson)(sheet.free_text)) {
            this.free_text_parse = JSON.parse(sheet.free_text);
        }
        else {
            this.free_text_parse = undefined;
        }
    }
    /**
     * Retourne le nom lisible d'une fiche annexe
     * @return {string}
     * @private
     */
    getDisplayName() {
        switch (this.kind) {
            case 'AutorisationSoinMineur':
                return 'Autorisation de soins sur mineur';
            case 'CertificatNaissance':
                return 'Certificat de naissance';
            case 'CompteRenduSmur':
                return 'Compte rendu SMUR';
            case 'LiaisonFormAtsu35':
                return 'Fiche de liaison ATSU';
            case 'RecuperationMaterielHelico':
                return 'Récupération matériel hélico';
            case 'RefusSignature':
                return 'Refus de signature';
            case 'RefusTransport':
            case 'RefusTransportSdis38':
                return 'Refus de transport';
            case 'RefusTransportEnglish':
                return 'Refus de transport (EN)';
            case 'RefusTransportMineur':
                return "Refus de transport d'un mineur";
            case 'IRCS':
                return 'IRCS';
            case 'ProcesVerbalSdis13':
                return 'Procés verbal';
            case 'RefusSoinsAndOrTransportSdis13':
                return 'Refus de transport et/ou de soins';
            case 'FnssdsCollision':
                return 'Fiche collision';
            default:
                return 'Document';
        }
    }
}
exports.AnnexSheetImpl = AnnexSheetImpl;
